import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowUpRight, Sparkles } from "lucide-react";
import { CIF } from "@/constants/testIds";

export const FinalCTA = ({ onEstimateClick, onWorkspaceClick }) => {
  return (
    <section
      data-testid={CIF.finalCta}
      className="relative py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-[2rem] bg-slate-950 text-white p-10 lg:p-16">
          <div className="absolute inset-0 bg-grid-dark opacity-40 pointer-events-none" />
          <div className="absolute -top-32 -right-24 h-[420px] w-[620px] bg-blue-500/20 rounded-full blur-3xl" />
          <div className="absolute -bottom-20 -left-10 h-[300px] w-[420px] bg-emerald-500/10 rounded-full blur-3xl" />

          <div className="relative max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/15 text-[10px] tracking-[0.22em] uppercase font-bold text-blue-200">
              <Sparkles className="h-3 w-3" /> Workspace · Estimated CIF™
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-[-0.03em] leading-[1.05] mt-6">
              Know your total import cost <span className="italic text-blue-300/90">before</span> you commit.
            </h2>
            <p className="text-[15px] lg:text-[16px] text-white/65 leading-relaxed mt-5 max-w-2xl">
              Estimate your landed cost, compare purchasing scenarios and make smarter import decisions — all inside one Workspace.
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-3">
              <Button
                data-testid={CIF.finalCtaPrimary}
                onClick={onEstimateClick}
                className="btn-shine h-12 rounded-full px-6 bg-white text-slate-900 hover:bg-slate-100 text-[14px] font-medium"
              >
                Estimate Your CIF <ArrowRight className="ml-1.5 h-4 w-4" />
              </Button>
              <Button
                data-testid={CIF.finalCtaSecondary}
                variant="outline"
                onClick={onWorkspaceClick}
                className="h-12 rounded-full px-6 bg-transparent border-white/25 hover:bg-white/10 hover:text-white text-white text-[14px] font-medium"
              >
                Create Your Free Workspace <ArrowUpRight className="ml-1.5 h-4 w-4" />
              </Button>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-[12px] text-white/55">
              <span>Factory Prices.</span>
              <span>Estimated Freight.</span>
              <span>One Workspace.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
